import { getProductPath } from "./productRouting";

// First homepage hero slide. Shared so the server-rendered homepage (server/seo.ts) paints the
// same banner the app's carousel opens on, which makes it the page's LCP image.
export const HOME_HERO_DESKTOP_MIN_WIDTH_PX = 768;

export const HOME_HERO_FIRST_SLIDE = {
  ariaLabel: "Go to the iPhone Duo product page",
  href: getProductPath({
    name: "Apple iPhone Duo",
    deviceType: "phones",
  }),
  imageUrl: "https://cdn.techfare.com/Product%20Images/iphone-duo-desktop.jpg",
  mobileImageUrl: "https://cdn.techfare.com/Product%20Images/iphone-duo-mobile.jpg",
};
